var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncreaseSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FBDFA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.263 26.0439V22.4187C41.263 22.1784 41.1652 21.9479 40.9912 21.7779C40.8172 21.6079 40.5812 21.5125 40.3351 21.5125H21.7784C21.5323 21.5125 21.2963 21.6079 21.1223 21.7779C20.9483 21.9479 20.8506 22.1784 20.8506 22.4187V26.0439H41.263Z",
    fill: "#E27007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8506 27.8564V40.5444C20.8506 40.7848 20.9483 41.0153 21.1223 41.1853C21.2963 41.3552 21.5323 41.4507 21.7784 41.4507H26.4176V27.8564H20.8506Z",
    fill: "#E27007"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2734 41.4507H40.3353C40.5814 41.4507 40.8174 41.3552 40.9914 41.1853C41.1654 41.0153 41.2631 40.7848 41.2631 40.5444V27.8564H28.2734V41.4507Z",
    fill: "#E27007"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseSale);
export default __webpack_public_path__ + "static/media/increaseSale.a47f1e29c617d0e9d57cbc97aa726769.svg";
export { ForwardRef as ReactComponent };